/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileDto
 */
export interface ProfileDto {
    /**
     * The user ID from the auth provider.
     * @type {string}
     * @memberof ProfileDto
     */
    id: string;
    /**
     * The display name.
     * @type {string}
     * @memberof ProfileDto
     */
    name: string;
    /**
     * The email address.
     * @type {string}
     * @memberof ProfileDto
     */
    email: string;
    /**
     * The URL to an external picture.
     * @type {string}
     * @memberof ProfileDto
     */
    picture: string | null;
    /**
     * Indicates if the user is an admin.
     * @type {boolean}
     * @memberof ProfileDto
     */
    isAdmin: boolean;
    /**
     * The api key for notifo.
     * @type {string}
     * @memberof ProfileDto
     */
    notifoApiKey: string | null;
    /**
     * The URL for notifo.
     * @type {string}
     * @memberof ProfileDto
     */
    notifoUrl: string | null;
}

/**
 * Check if a given object implements the ProfileDto interface.
 */
export function instanceOfProfileDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "picture" in value;
    isInstance = isInstance && "isAdmin" in value;
    isInstance = isInstance && "notifoApiKey" in value;
    isInstance = isInstance && "notifoUrl" in value;

    return isInstance;
}

export function ProfileDtoFromJSON(json: any): ProfileDto {
    return ProfileDtoFromJSONTyped(json, false);
}

export function ProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'picture': json['picture'],
        'isAdmin': json['isAdmin'],
        'notifoApiKey': json['notifoApiKey'],
        'notifoUrl': json['notifoUrl'],
    };
}

export function ProfileDtoToJSON(value?: ProfileDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'email': value.email,
        'picture': value.picture,
        'isAdmin': value.isAdmin,
        'notifoApiKey': value.notifoApiKey,
        'notifoUrl': value.notifoUrl,
    };
}

